import React, { useEffect, useState } from "react";
import { Button, Card, CardHeader } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { Table, TableRow } from "../../../components/Table";
import CustomerDetailsFileUpload from "../../../components/Custom/Modals/CustomerDetails/CustomerDetailsFileUpload";
import {
    customerDetailsGet,
    useCustomerDetailsState,
} from "../../../redux/slices/customerDetailsSlice";
import { onFixed, seperator } from "../../../helperFunctions";
import CustomerDetailsParseModal from "./CustomerDetailsParseModal";
import { TRA_FILTER } from "../../../constant";
import { Box } from "@mui/material";
import LinearProgress, {
    linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import { useRole } from "../../../redux/slices/authSlice";

const CustomerDetails = () => {
    const dispatch = useDispatch();
    const [filter, setFilter] = useState(TRA_FILTER);

    const [parseData, setparseData] = useState(null);
    const customerDetailsState = useCustomerDetailsState();
    const { customerDetailsIsLoading } = useSelector(
        (state) => state.customerDetails
    );
    const [filterColumns, setFilterColumns] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const role = useRole("Customer Details");
    const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
        height: 20,
        borderRadius: 4,
        [`&.${linearProgressClasses.colorPrimary}`]: {
            backgroundColor:
                theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
        },
        [`& .${linearProgressClasses.bar}`]: {
            borderRadius: 4,
            backgroundColor: theme.palette.mode === "light" ? "#76bdff" : "#308fe8",
        },
    }));

    const columns = [
        {
            title: "ID",
            name: "id",
        },
        {
            title: "FILE INFO",
            name: "fileName",
            Cell: (data) => {
                return (
                    <>
                        <div className="cell-order">
                            <div className="order-singal-div">
                                <p>
                                    <span>Create : </span>
                                    {data?.created_at || ""}
                                </p>
                            </div>
                            <div className="order-singal-div">
                                <p>
                                    <span>Update : </span>
                                    {data?.updated_at || ""}
                                </p>
                            </div>
                            <div className="order-singal-div">
                                <p>
                                    <span>Name : </span>
                                    {data?.fileName || ""}
                                </p>
                            </div>
                        </div>
                    </>
                );
            },
        },
        {
            title: "UTR COUNT	",
            name: "totalCnt",
            Cell: (data) => {
                return (
                    <>
                        <div className="cell-order">
                            <div className="order-singal-div">
                                <p>
                                    <span>Total Count : </span>
                                    {`${seperator(data?.totalCount, false)}`}
                                </p>
                            </div>
                            <div className="order-singal-div">
                                <p>
                                    <span>Parse Data : </span>
                                    {seperator(+data?.parsedData?.length, false) || 0}
                                </p>
                            </div>
                        </div>
                    </>
                );
            },
        },
        // {
        //     title: "PROGRESS",
        //     name: "Development",
        //     Cell: (data) => {
        //         function calculateProgressPercentage(data) {
        //             if (data?.totalCount == 0) {
        //                 return 0;
        //             }
        //             const completedCount = data?.totalCount - data?.pendingCount;
        //             const percentage = (completedCount / data?.totalCount) * 100;
        //             return percentage;
        //         }
        //         const todata = calculateProgressPercentage(data);
        //         const progressPer = todata > 100 ? 100 : todata;
        //         return (
        //             <>
        //                 <div className="position-relative">
        //                     <Box sx={{ flexGrow: 1 }}>
        //                         <BorderLinearProgress
        //                             variant="determinate"
        //                             value={progressPer}
        //                         />
        //                     </Box>
        //                     <div className="progress-position text-center">
        //                         <span>{onFixed(progressPer)}%</span>
        //                     </div>
        //                 </div>
        //             </>
        //         );
        //     },
        // },
        {
            title: "ACTION",
            Cell: (data) => {
                return (
                    <>
                        <div className="d-flex">
                            {!!data?.parsedData?.length ? (
                                <Button
                                    color="primary"
                                    className="btn-smallsize"
                                    onClick={() => setparseData(data)}
                                >
                                    Show Parsed Data
                                </Button>
                            ) : null}
                        </div>
                    </>
                );
            },
        },
    ];

    useEffect(() => {
        const newColumns = columns?.map((item) => item?.name);
        setFilterColumns(newColumns);
    }, []);

    const CustomerDetailsGet = async () => {
        try {
            const { isFilter, page_no, limit, ...rest } = filter;
            const payload = isFilter
                ? { filter_data: {}, page_no, limit }
                : {
                    page_no,
                    limit,
                };
            await dispatch(customerDetailsGet(payload)).unwrap();
        } catch (err) { }
    };

    useEffect(() => {
        if (role?.includes("customer-details")) {
            CustomerDetailsGet();
        }
    }, [filter, role]);

    return (
        <>
            <Card>
                <CardHeader className="flex-column align-items-start">
                    <div className="d-flex align-items-center w-100 justify-content-between">
                        <h4 className="main-title">
                            <b>Customer Details</b>
                        </h4>
                        <Button
                            color="primary"
                            title="Add Customer Details"
                            onClick={() => setIsModalOpen(true)}
                        >
                            Add Customer Details
                        </Button>
                    </div>
                    <div
                        className="d-flex my-xl-auto right-content align-items-end button-space"
                        style={{ flexWrap: "wrap" }}
                    ></div>
                </CardHeader>
                <Table
                    columns={columns}
                    isLoading={customerDetailsIsLoading}
                    data={customerDetailsState?.data || []}
                    isData={!!customerDetailsState?.data?.length}
                    filterColumns={filterColumns}
                    count={customerDetailsState?.total_item || 0}
                    pagination={filter}
                    isExpandable={false}
                    handlePaginationChange={(pagination) => {
                        setFilter({
                            ...filter,
                            ...pagination,
                        });
                    }}
                    onColumnsChange={(columns) => {
                        setFilterColumns(columns);
                    }}
                >
                    {customerDetailsState?.data?.map((item, index) => {
                        return (
                            <TableRow
                                key={index}
                                columns={columns}
                                item={item}
                                filterColumns={filterColumns}
                                isExpandable={false}
                            />
                        );
                    })}
                </Table>
            </Card>
            <CustomerDetailsFileUpload
                isModalOpen={isModalOpen}
                onGet={() => CustomerDetailsGet()}
                onCloseModal={() => {
                    setIsModalOpen(false);
                }}
            />
            <CustomerDetailsParseModal
                data={parseData}
                onClose={() => setparseData(null)}
                onGet={() => CustomerDetailsGet()}
            />
        </>
    );
};

export default CustomerDetails;
